import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "dashboard"
};
const _hoisted_2 = {
  class: "grid-content grid-con-1"
};
const _hoisted_3 = {
  class: "grid-cont-right"
};
const _hoisted_4 = {
  class: "grid-num"
};
const _hoisted_5 = {
  class: "grid-content grid-con-2"
};
const _hoisted_6 = {
  class: "grid-cont-right"
};
const _hoisted_7 = {
  class: "grid-num"
};
const _hoisted_8 = {
  class: "grid-content grid-con-3"
};
const _hoisted_9 = {
  class: "grid-cont-right"
};
const _hoisted_10 = {
  class: "grid-num"
};
const _hoisted_11 = {
  class: "grid-content grid-con-3"
};
const _hoisted_12 = {
  class: "grid-cont-right"
};
const _hoisted_13 = {
  class: "grid-num"
};
import { onMounted, ref } from 'vue';
import { ChatDotRound, TrendCharts, User } from "@element-plus/icons-vue";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import * as echarts from 'echarts';
export default {
  __name: 'Dashboard',
  setup(__props) {
    const stats = ref({
      users: 0,
      chats: 0,
      tokens: 0,
      rewards: 0
    });
    const loading = ref(true);
    onMounted(() => {
      const chartUsers = echarts.init(document.getElementById("chart-users"));
      const chartTokens = echarts.init(document.getElementById("chart-tokens"));
      const chartIncome = echarts.init(document.getElementById("chart-income"));
      httpGet('/api/admin/dashboard/stats').then(res => {
        stats.value.users = res.data.users;
        stats.value.chats = res.data.chats;
        stats.value.tokens = res.data.tokens;
        stats.value.income = res.data.income;
        const chartData = res.data.chart;
        loading.value = false;
        const x = [];
        const dataUsers = [];
        for (let k in chartData.users) {
          x.push(k);
          dataUsers.push(chartData.users[k]);
        }
        chartUsers.setOption({
          xAxis: {
            data: x
          },
          yAxis: {},
          series: [{
            data: dataUsers,
            type: 'line',
            label: {
              show: true,
              position: 'bottom',
              textStyle: {
                fontSize: 18
              }
            }
          }]
        });
        const dataTokens = [];
        for (let k in chartData.historyMessage) {
          dataTokens.push(chartData.historyMessage[k]);
        }
        chartTokens.setOption({
          xAxis: {
            data: x
          },
          yAxis: {},
          series: [{
            data: dataTokens,
            type: 'line',
            label: {
              show: true,
              position: 'bottom',
              textStyle: {
                fontSize: 18
              }
            }
          }]
        });
        const dataIncome = [];
        for (let k in chartData.orders) {
          dataIncome.push(chartData.orders[k]);
        }
        chartIncome.setOption({
          xAxis: {
            data: x
          },
          yAxis: {},
          series: [{
            data: dataIncome,
            type: 'line',
            label: {
              show: true,
              position: 'bottom',
              textStyle: {
                fontSize: 18
              }
            }
          }]
        });
      }).catch(e => {
        ElMessage.error("获取统计数据失败：" + e.message);
      });
      window.onresize = function () {
        // 自适应大小
        chartUsers.resize();
        chartTokens.resize();
        chartIncome.resize();
      };
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        class: "mgb20",
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            shadow: "hover",
            "body-style": {
              padding: '0px'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
              class: "grid-con-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(User))]),
              _: 1
            }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(stats.value.users), 1), _cache[0] || (_cache[0] = _createElementVNode("div", null, "今日新增用户", -1))])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            shadow: "hover",
            "body-style": {
              padding: '0px'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_icon, {
              class: "grid-con-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ChatDotRound))]),
              _: 1
            }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(stats.value.chats), 1), _cache[1] || (_cache[1] = _createElementVNode("div", null, "今日新增对话", -1))])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            shadow: "hover",
            "body-style": {
              padding: '0px'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
              class: "grid-con-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(TrendCharts))]),
              _: 1
            }), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(stats.value.tokens), 1), _cache[2] || (_cache[2] = _createElementVNode("div", null, "今日消耗 Tokens", -1))])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            shadow: "hover",
            "body-style": {
              padding: '0px'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_icon, {
              class: "grid-con-icon"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("i", {
                class: "iconfont icon-reward"
              }, null, -1)])),
              _: 1
            }), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, "￥" + _toDisplayString(stats.value.income), 1), _cache[4] || (_cache[4] = _createElementVNode("div", null, "今日入账", -1))])])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mgb20",
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("div", {
            class: "e-chart"
          }, [_createElementVNode("div", {
            id: "chart-users",
            style: {
              "height": "400px"
            }
          }), _createElementVNode("div", {
            class: "title"
          }, "最近7日用户注册")], -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("div", {
            class: "e-chart"
          }, [_createElementVNode("div", {
            id: "chart-tokens",
            style: {
              "height": "400px"
            }
          }), _createElementVNode("div", {
            class: "title"
          }, "最近7日Token消耗")], -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("div", {
            class: "e-chart"
          }, [_createElementVNode("div", {
            id: "chart-income",
            style: {
              "height": "400px"
            }
          }), _createElementVNode("div", {
            class: "title"
          }, "最近7日收入")], -1)])),
          _: 1
        })]),
        _: 1
      })])), [[_directive_loading, loading.value]]);
    };
  }
};